var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.1012L5.8983 22.0001L11.3932 17.9139C11.5855 17.7709 11.7382 17.6011 11.8423 17.4143C11.9464 17.2274 12 17.0272 12 16.8249V7.17281C12 6.97051 11.9464 6.77029 11.8423 6.58342C11.7382 6.39657 11.5855 6.2268 11.3932 6.08381L5.90169 2.00012L2.00339 4.89903L10.0864 10.9099C10.2789 11.053 10.4315 11.2229 10.5356 11.4099C10.6397 11.5969 10.6932 11.7973 10.693 11.9997C10.6929 12.2021 10.639 12.4025 10.5347 12.5894C10.4303 12.7763 10.2775 12.9462 10.0848 13.0891L2 19.1012Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRight);
export default __webpack_public_path__ + "static/media/blue-right.0d45d0881877415b06bb4622f94e938f.svg";
export { ForwardRef as ReactComponent };